(function () {
  const ALPINE_SRC =
    "https://cdn.shopify.com/s/files/1/0731/6566/8628/files/alpine.min.js?v=1679064730";
  const SWIPER_SRC =
    "https://cdn.shopify.com/s/files/1/0731/6566/8628/files/swiper-bundlee.min.js?v=1678960146";

  function loadScript(src) {
    const existing = document.querySelector(`script[src="${src}"]`);

    if (existing?.dataset.loaded === "true") {
      return Promise.resolve();
    }

    if (existing) {
      return new Promise((resolve, reject) => {
        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener("error", reject, { once: true });
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.addEventListener(
        "load",
        () => {
          script.dataset.loaded = "true";
          resolve();
        },
        { once: true },
      );
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    });
  }

  let alpinePromise;
  function loadAlpine() {
    if (!alpinePromise) {
      alpinePromise = loadScript(ALPINE_SRC);
    }
    return alpinePromise;
  }

  let swiperPromise;
  function loadSwiper() {
    if (!swiperPromise) {
      swiperPromise = loadScript(SWIPER_SRC);
    }
    return swiperPromise;
  }

  window.loadAlpine = loadAlpine;
  window.loadSwiper = loadSwiper;

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  onReady(() => {
    loadAlpine();

    if (document.querySelector(".swiper, swiper-container")) {
      loadSwiper();
    }
  });
})();
